<template>
  <header id="header" :class="{ 'block-when-above-video': has_video }">
    <nav id="nav-desktop" class="mouse-blocker">
      <a :href="lang_url" class="logo" title="Pacura Studio">
        <Logo />
      </a>
      <ul class="nav nav-left">
        <li v-for="link in links.main_menu_1" :key="link.url">
          <router-link
            :data-page-type="link.type"
            :data-page-id="link.page_id"
            v-bind:to="{ path: link.url }"
            @click.native="handleRoute"
            >{{ link.name }}</router-link
          >
        </li>
      </ul>
      <ul class="nav nav-right">
        <!-- <li>
          <router-link
            data-page-type="categories"
            data-page-id=""
            v-bind:to="{ path: shop_url }"
            @click.native="handleRoute"
            >{{ trans.shop }}</router-link
          >
        </li> -->
        <li><a target="_blank" href="https://sklep.pacura.co/">{{ trans.shop }}</a></li>
        <li v-for="link in links.main_menu_2" :key="link.url">
          <router-link
            :data-page-type="link.type"
            :data-page-id="link.page_id"
            v-bind:to="{ path: link.url }"
            @click.native="handleRoute"
            >{{ link.name }}</router-link
          >
        </li>
        <li>
          <Basket
            v-bind:products_quantity="productsQuantity"
            v-on:handle_sidebar="handleSidebar"
          />
        </li>
        <li class="lang" v-if="current_lang == 'pl'">
          <span>PL</span>
          <a lang="en" href="/en/">EN</a>
        </li>
        <li class="lang" v-if="current_lang == 'en'">
          <a lang="pl" href="/">PL</a>
          <span>EN</span>
        </li>
      </ul>
    </nav>
    <nav id="nav-mobile">
      <div class="header-visible">
        <a :href="lang_url" class="logo-text" title="Pacura Studio">
          <LogoText />
        </a>
        <ul class="lang">
          <li class="lang" v-if="current_lang == 'pl'">
            <span>PL</span>
            <a lang="en" href="/en/">EN</a>
          </li>
          <li class="lang" v-if="current_lang == 'en'">
            <a lang="pl" href="/">PL</a>
            <span>EN</span>
          </li>
        </ul>
        <div class="controls">
          <Basket
            v-bind:products_quantity="productsQuantity"
            v-on:handle_sidebar="handleSidebar"
          />

          <a
            id="switch-menu"
            href="#"
            class="menu-button"
            title="open menu"
            @click="handleMenu"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </a>
        </div>
      </div>

      <div class="header-menu">
        <ul class="nav">
          <li v-for="link in links.main_menu_1" :key="link.url">
            <router-link
              :data-page-type="link.type"
              :data-page-id="link.page_id"
              v-bind:to="{ path: link.url }"
              @click.native="handleRoute"
              >{{ link.name }}</router-link
            >
          </li>
          <li>
            <router-link
              data-page-type="categories"
              data-page-id=""
              v-bind:to="{ path: shop_url }"
              @click.native="handleRoute"
              >{{ trans.shop }}</router-link
            >
          </li>
          <li v-for="link in links.main_menu_2" :key="link.url">
            <router-link
              :data-page-type="link.type"
              :data-page-id="link.page_id"
              v-bind:to="{ path: link.url }"
              @click.native="handleRoute"
              >{{ link.name }}</router-link
            >
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import Logo from "@/components/Logo.vue";
import Basket from "@/components/Basket.vue";
import LogoText from "@/components/LogoText.vue";

export default {
  name: "App",
  components: {
    Logo,
    Basket,
    LogoText,
  },
  data() {
    return {
      products_quantity: null,
      links: window.APP_INFO.menu_links,
      lang_url:
        window.APP_INFO.init.lang_url[window.APP_INFO.init.lang_url["current"]],
      shop_url: window.APP_INFO.init.shop_url,
      current_lang: window.APP_INFO.init.lang_url["current"],
      trans: {
        shop: window.APP_INFO.trans.shop,
      },
    };
  },
  props: {
    has_video: {
      type: String,
      required: false,
    },
    client_cart: {
      type: Array,
      required: false,
    },
    /*products_quantity: {
            type: Number,
                    required: false
        }*/
  },
  computed: {
    productsQuantity: function () {
      let vm = this;
      let total_count = 0;
      let i;
      for (i = 0; i < vm.client_cart.length; i++) {
        total_count += parseInt(vm.client_cart[i].quantity, 10);
      }
      console.log("naliczylem " + total_count);
      return total_count === 0 ? null : total_count;
    },
  },
  methods: {
    handleMenu(e) {
      e.preventDefault();
      this.$emit("menu_state_changed", e);
    },
    handleSidebar(e) {
      //e.preventDefault();
      this.$emit("handle_sidebar");
    },
    handleRoute(e) {
      this.$emit("reload", {
        type: e.target.dataset.pageType,
        href: e.target.attributes.href,
        id: e.target.dataset.pageId,
      });
    },
  },
};
</script>

<style lang="scss">
#header {
  top: 0;
  left: 0;
  z-index: 100;
}
#nav-mobile .nav li:first-child a,
#nav-desktop .nav-left li:first-child a {
    border-color: transparent;
}
    .router-link-active {
        border-bottom: 2px solid currentColor;
    }
</style>